import { useCallback, useEffect, useState } from "react";
import { useLocation } from "wouter";

/**
 * Off-canvas nav drawer state for narrow viewports (charter A-10: the shell
 * had zero width-based media queries and a `--shell-nav-width-collapsed`
 * token nothing read). Below `shell.css`'s mobile breakpoint the sidebar
 * becomes a fixed drawer that starts collapsed to that token's width (a
 * visible "there's a menu here" rail) and expands to the full nav width when
 * open; above the breakpoint this state is inert by construction — the CSS
 * for `.nav-sidebar.is-open` only exists inside the `max-width` media query,
 * so toggling it on desktop has no visual effect.
 *
 * Closes automatically on navigation so a link tap doesn't leave the drawer
 * covering the page it just navigated to.
 */
export function useNavDrawer() {
  const [isOpen, setIsOpen] = useState(false);
  const [location] = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const toggle = useCallback(() => setIsOpen((open) => !open), []);
  const close = useCallback(() => setIsOpen(false), []);

  return { isOpen, toggle, close };
}
